import { VIDEOS_TEST_IDS } from '../../videos.const'
import type { AcademyVideo } from '../../videos.interface'
import { AcademyVideoCard } from '../AcademyVideoCard/AcademyVideoCard'

import styles from './VideosGrid.module.scss'

type VideosGridProps = {
  videos: AcademyVideo[]
}

export function VideosGrid({ videos }: VideosGridProps) {
  if (videos.length === 0) {
    return <p className={styles.empty}>No videos match the selected topics.</p>
  }

  const rows: AcademyVideo[][] = []
  for (let index = 0; index < videos.length; index += 2) {
    rows.push(videos.slice(index, index + 2))
  }

  return (
    <div className={styles.grid} data-testid={VIDEOS_TEST_IDS.grid}>
      {rows.map((row) => (
        <div key={row.map((video) => video.slug).join('-')} className={styles.row}>
          {row.map((video) => (
            <AcademyVideoCard key={video.slug} video={video} />
          ))}
        </div>
      ))}
    </div>
  )
}
